// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as ZonesAndClustersRepoConfig from "./ZonesAndClustersRepoConfig.bs.js";

function fetchZones(geo_region_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/geo_regions/current_zones?geo_region_id=" + geo_region_id);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ZonesAndClustersRepoConfig.ZoneListResponseConverter.execute, result);
                        });
            });
}

function fetchClusters(geo_region_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/geo_regions/current_clusters?geo_region_id=" + geo_region_id);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ZonesAndClustersRepoConfig.ClusterListResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchZones: fetchZones,
  fetchClusters: fetchClusters
};

export {
  T ,
  
}
/* Config Not a pure module */
